import React from "react";
import {getUnderOver} from "../../../constants/rollet";

export default (props) => {
    let rows = [];
    const {underOverItems} = props;
    for (let i = 0; i < underOverItems?.length; i++) {
        let cols = [];
        let rowNum = underOverItems[i];
        for (let j = 0; j < rowNum?.length; j++) {
            const col = rowNum[j];
            cols.push(<td
                key={j}
                id={"keno-history-key" + j}
                width="5%"
            >
                {(col.length > 0 ?
                    <div className="odd-even-cell">
                        {col ? (
                            <span className={`circle-number text-black bg-color-${getUnderOver(col.split("_")[1])}`}>
                {col.split("_")[1]}
              </span>
                        ) : (
                            <span/>
                        )}
                    </div>
                    : <span/>)}
            </td>);
        }
        rows.push(<tr key={i}>{cols}</tr>)
    }

    return rows;
}